import { faWarning } from '@fortawesome/pro-regular-svg-icons'
import { Alert, type AlertProps } from '@mantine/core'
import { useMemo } from 'react'

import { useQueryGetAllBookingInsurances } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { type CoreBookingProduct, type ParameterID } from '@flecto/types'
import { Icon } from '@flecto/ui'

export type AlertBookingHasInsuredProductsProps = Omit<AlertProps, 'children'> & {
  bookingId?: ParameterID
  bookingProductsToPickup?: CoreBookingProduct[]
}

export function AlertBookingHasInsuredProducts({
  bookingId,
  bookingProductsToPickup,
  ...props
}: AlertBookingHasInsuredProductsProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_pickup_return' })

  const { data: bookingInsurances } = useQueryGetAllBookingInsurances({
    bookingId,
  })

  const hasItemInsured = useMemo(() => {
    let hasInsurance = false

    bookingProductsToPickup?.forEach((bi) => {
      const insurance = bookingInsurances?.insurance?.find(
        (item) =>
          String(item.id) === String(bi.product.id) && item.status === 'active'
      )

      if (insurance) {
        hasInsurance = true
      }
    })

    return hasInsurance
  }, [bookingProductsToPickup, bookingInsurances])

  if (!hasItemInsured) {
    return null
  }

  return (
    <Alert
      {...props}
      color='orange'
      icon={<Icon icon={faWarning} />}
      title={t('alert_pickup_booking_has_insured_items_title')}
    >
      {t('alert_pickup_booking_has_insured_items_description')}
    </Alert>
  )
}
